import * as yup from 'yup';
const validation = {
  Building: yup.object({
    buildingName: yup.string().required('Building Name is required.'),
    buildingAddress: yup.string().required('Address is required.'),
    notes: yup
      .string()
      .max(800, 'Notes must be at most 800 characters.')
      .required('Note is required.'),
    bluePrints: yup
      .array()
      .of(
        yup.object().shape({
          title: yup.string().required('Title is required.'),
        }),
      )
      .min(1, 'Add at least 1 blueprint.'),
  }),
};

export default validation;

export const updateBuildingValidation = (hasBluePrintUrl: boolean) => {
  return yup.object({
    buildingName: yup.string().required('Building Name is required.'),
    buildingAddress: yup.string().required('Address is required.'),
    notes: yup
      .string()
      .max(360, 'Notes must be at most 800 characters.')
      .required('Note is required.'),
    bluePrints: hasBluePrintUrl
      ? yup
        .array()
        .of(
          yup.object().shape({
            title: yup.string().required('Title is required.'),
          }),
        )
        .min(0, 'Add at least 1 blueprint.')
      : yup
        .array()
        .of(
          yup.object().shape({
            title: yup.string().required('Title is required.'),
          }),
        )
        .min(1, 'Add at least 1 blueprint.'),
  });
};
